import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  LinearProgress
} from "@mui/material";
import WSButton from "../../Components/Button/WSButton";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";

// Dummy Fab Credit Data
const dummyCard = {
  id: "1",
  cardId: "#123",
  points: 12, // Current points
  targetPoints: 50, // Points needed to redeem
  customer: "John Doe",
  date: "17/08/2025",
  status: "pending"
};

// Dummy Usage History
const history = [
  { id: "1", date: "15/08/2025", pointsUsed: 10 },
  { id: "2", date: "12/08/2025", pointsUsed: 5 },
  { id: "3", date: "10/08/2025", pointsUsed: 8 }
];

const FabCreditDetail: React.FC = () => {
  const [fabCredit] = useState(dummyCard);
  const [usageHistory] = useState(history);

  // Calculate redemption progress
  const progress = (fabCredit.points / fabCredit.targetPoints) * 100;

  const fabColumn: IColumns[] = [
    {
      header: "Date",
      fieldName: "date",
      type: "default",
      sortable: true,
      sortKey: "date"
    },
    {
      header: "Point Used",
      fieldName: "pointsUsed",
      type: "default",
      sortable: true,
      sortKey: "pointsUsed"
    }
  ];

  return (
    <Grid container spacing={3} padding={3}>
      {/* Customer & Fab Credit Details */}
      <Grid item xs={12} md={6}>
        <Card sx={{ padding: 2 }}>
          <CardContent>
            <Typography variant="h5">Fab Credit Details</Typography>
            <Typography variant="body1">
              <strong>Customer:</strong> {fabCredit.customer}
            </Typography>
            <Typography variant="body1">
              <strong>Card ID:</strong> {fabCredit.cardId}
            </Typography>
            <Typography variant="body1">
              <strong>Date:</strong> {fabCredit.date}
            </Typography>
            <Typography variant="body1">
              <strong>Status:</strong> {fabCredit.status}
            </Typography>
            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Points: {fabCredit.points} / {fabCredit.targetPoints}
            </Typography>
            {/* Progress Bar */}
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{ height: 10, borderRadius: 5, marginTop: 1 }}
            />
          </CardContent>
        </Card>
      </Grid>

      {/* Usage History */}
      <Grid item xs={12} md={6}>
        <Card sx={{ padding: 2 }}>
          <CardContent>
            <Typography variant="h5">Usage History</Typography>
            {/* <TableContainer component={Paper} sx={{ marginTop: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Points Used</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {usageHistory.map((entry) => (
                    <TableRow key={entry.id}>
                      <TableCell>{entry.date}</TableCell>
                      <TableCell>{entry.pointsUsed}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer> */}
            <WSDataGrid id="history" columns={fabColumn} data={usageHistory} />
          </CardContent>
        </Card>
      </Grid>

      {/* Redeem Button */}
      <Grid item xs={12} textAlign="center">
        <WSButton
          id="radeem-btn"
          label="Redeem Points"
          variant="contained"
          color="primary"
          disabled={fabCredit.points < fabCredit.targetPoints} // Disable if points are below target
          sx={{ marginTop: 2 }}
        />
      </Grid>
    </Grid>
  );
};

export default FabCreditDetail;
